import styled from "styled-components";

interface BackgroundColors {
  color: string;
}

export const ExistingCardData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid lightgrey;
  border-radius: 1vh;
  width: 100%;
  height: 85px;
  cursor: pointer;
  &:hover {
    background-color: lightgrey;
  }
`;

export const CardType = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  place-content: center;
  align-items: center;
  width: 90px;
  height: 100%;
  padding: 10px 0;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardNumber = styled.p`
  margin: 0;
`;

export const CardExpire = styled.p`
  margin: 0;
  font-size: 12px;
`;

export const StyleCard = styled.div<BackgroundColors>`
  background: ${(props) => props.color};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border: 1px solid #dfe7ef;
  border-radius: 1vh;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: lightgray;
  }
`;
